(function () {
  'use strict';

  // ── Dropdown (ATC) ──────────────────────────────────────────────────────────

  function initDropdowns(root) {
    root.querySelectorAll('[data-product-accordion]').forEach(function (accordion) {
      accordion.querySelectorAll('[data-dropdown-trigger]').forEach(function (trigger) {
        if (trigger._paDropdownInit) return;
        trigger._paDropdownInit = true;

        var wrap = trigger.closest('.quick-buy-dropdown');
        var menu = wrap && wrap.querySelector('[data-dropdown-menu]');
        if (!menu) return;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = wrap.classList.contains('open');

          accordion.querySelectorAll('.quick-buy-dropdown').forEach(function (d) {
            d.classList.remove('open');
            d.querySelector('[data-dropdown-menu]').style.display = 'none';
          });

          if (!isOpen) {
            menu.style.display = 'block';
            wrap.classList.add('open');
          }
        });
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-product-accordion] .quick-buy-dropdown')) {
      document.querySelectorAll('[data-product-accordion] .quick-buy-dropdown').forEach(function (d) {
        d.classList.remove('open');
        var m = d.querySelector('[data-dropdown-menu]');
        if (m) m.style.display = 'none';
      });
    }
  });

  // ── Image switcher + autoplay ───────────────────────────────────────────────

  function initImageSwitcher(root) {
    root.querySelectorAll('[data-product-accordion]').forEach(function (accordion) {
      var variantOptionsEl = accordion.querySelector('[data-variant-options]');
      if (!variantOptionsEl) return;

      var variantOptions = JSON.parse(variantOptionsEl.textContent || '[]');
      var track = accordion.querySelector('[data-image-track]');
      var slides = track ? Array.from(track.querySelectorAll('[data-variant-slide]')) : [];
      if (!slides.length || !variantOptions.length) return;

      var currentIndex = 0;

      // Seed selected options from initially active buttons
      var selectedOptions = {};
      accordion.querySelectorAll('.product-accordion__option-btn.is-active[data-option-index]').forEach(function (btn) {
        selectedOptions[btn.dataset.optionIndex] = btn.dataset.optionValue;
      });

      function showSlide(index, syncButtons) {
        currentIndex = index;
        slides.forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.variantSlide, 10) === index);
        });
        if (syncButtons && variantOptions[index]) {
          variantOptions[index].forEach(function (val, oi) {
            selectedOptions[String(oi)] = val;
            accordion.querySelectorAll('[data-option-index="' + oi + '"]').forEach(function (b) {
              b.classList.toggle('is-active', b.dataset.optionValue === val);
            });
          });
        }
      }

      // Option button clicks
      accordion.querySelectorAll('[data-option-index]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var oi = btn.dataset.optionIndex;
          selectedOptions[oi] = btn.dataset.optionValue;

          accordion.querySelectorAll('[data-option-index="' + oi + '"]').forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.optionValue === btn.dataset.optionValue);
          });

          var vi = variantOptions.findIndex(function (opts) {
            return opts.every(function (val, i) {
              return selectedOptions[String(i)] === val;
            });
          });

          if (vi !== -1) {
            showSlide(vi, false); // buttons already updated above
          }
        });
      });

      showSlide(0, false);
    });
  }

  // ── Init ────────────────────────────────────────────────────────────────────

  function init(root) {
    initDropdowns(root);
    initImageSwitcher(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
